export enum PopUpMode {
    UPDATE = "modification",
    CREATE = "création",
    DELETE = "suppression",
}
